import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';

class ProductNew extends React.Component {
  handleClose = () => {
    this.props.handleClose();
  }
  handleCopyTemplateOpen = () => {
    this.props.handleCopyTemplateOpen();
  }
  handleCreateOpen = () => {
    this.props.handleCreateOpen();
  }

  render() {

    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        primary
        label={t('product.template')}
        onTouchTap={this.handleCopyTemplateOpen}
      />,
      <FlatButton
        primary
        label={t('product.create')}
        onTouchTap={this.handleCreateOpen}
      />,
    ];

    return (
      <Dialog
          open={this.props.open}
          onRequestClose={this.handleClose}
          actions={actions}
          title={t('product.new')}
        >
          {t('product.newProductDialog')}
          {this.props.children}
        </Dialog>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductNew);



// WEBPACK FOOTER //
// ./src/Product/ProductNew.js